<template>
<div>
    <h1 class="title">{{ texts.passwordRecovery }}</h1>
    <div class="page-form">

        <b-field
            :label="`${texts.username} (*)`"
            :message="errors.username ? texts.errors.username : undefined"
            :type="errors.username ? 'is-danger' : undefined"
        >
            <b-input
                v-model="form.username"
                :placeholder="texts.username"
                type="text"
            />
        </b-field>

        <b-field
            :label="`${texts.email} (*)`"
            :message="errors.email ? texts.errors.email : undefined"
            :type="errors.email ? 'is-danger' : undefined"
        >
            <b-input
                v-model="form.email"
                :placeholder="texts.email"
                type="email"
            />
        </b-field>

    </div>

    <div class="actions">
        <button class="button is-warning actions-btn" @click="back()">
            <b-icon
                pack="fas"
                icon="undo-alt">
            </b-icon>
        </button>
        <button class="button is-info actions-btn" @click="recovery()">
            <b-icon
                pack="fas"
                icon="paper-plane">
            </b-icon>
        </button>
    </div>

</div>
</template>

<script>
import { Utils } from '../../mixins/Utils';
import HealthCareService from '../../services/HealthCareService';

export default {
    name: 'Recovery',
    mixins: [ Utils ],
    data () {
        return {
            config: {},
            texts: {},
            form: {
                username: null,
                email: null,
            },
            errors: {
                username: null,
                email: null,
            }
        }
    },
    mounted() {
        this.config = JSON.parse(JSON.stringify(this.$parent.config));
        this.texts = JSON.parse(JSON.stringify(this.$parent.texts));
    },
    methods: {
        back() {
            this.$router.push('/');
        },
        validateForm() {
            this.errors.username = !this.form.username;
            this.errors.email = !this.form.email;
            let isValid = true;
            for (let field in this.errors) {
                if (this.errors.hasOwnProperty(field)) {
                    if (this.errors[field] === true) isValid = false;
                }
            }
            return isValid;
        },
        recovery() {
            const isValid = this.validateForm();
            if (!isValid) return;
            HealthCareService.passwordRecovery({
                "username": this.form.username,
                "email": this.form.email
            })
            .then(res => {
                this.$buefy.toast.open({ message: this.texts.emailSent, type: 'is-success', position: 'is-bottom' });
                setTimeout(() => {
                    this.$router.push('/');
                }, 1000);
            })
            .catch(error => {
                const err = (error.response && error.response.data && error.response.data.error) ? error.response.data.error : 'Error';
                this.$buefy.toast.open({ message: err, type: 'is-danger', position: 'is-bottom' });
            })
        },
    }
}
</script>

<style scoped lang="scss">
.page-form {
    width: 500px;
    max-width: 90%;
    margin: 0 auto;
    text-align: left;
}
.actions {
    position: absolute;
    bottom: 20px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
    .actions-btn {
        border-radius: 30px;
        height: 60px;
        width: 60px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/professional/Recovery.vue